import { Label } from "@monsterindia/global-ui-components";
import { FC, memo, useState } from "react";
import { Controller } from "react-hook-form";

import { DropdownOptionType } from "../../../../../../types";
import { LgbtqiaApopControllerType } from "../../../../../../types/apop";

type TextAreaControllerProps = {
  subType: DropdownOptionType | null;
} & LgbtqiaApopControllerType;

const TextAreaController: FC<TextAreaControllerProps> = ({
  name,
  control,
  label,
  subType,
  setIsUserInput,
}) => {
  const isDescriptionRequired = subType?.text?.toLowerCase() === "other";
  const maxCharLimit = 1000;
  const [charCount, setCharCount] = useState(maxCharLimit);

  return (
    <div className="l1-w-full">
      <Label
        className="l1-flex l1-p-0"
        labelText={label}
        isRequired={isDescriptionRequired}
      >
        <Controller
          name={name}
          control={control}
          rules={{
            required: isDescriptionRequired,
            minLength: isDescriptionRequired ? 4 : undefined,
            maxLength: maxCharLimit,
          }}
          render={({ field }) => (
            <>
              <textarea
                {...field}
                className="l1-m-0 l1-w-full l1-rounded-[4px] l1-border l1-border-[#d2d1d6] l1-p-3 l1-text-sm l1-font-normal l1-outline-none"
                rows={4}
                placeholder={label}
                onFocus={() => setIsUserInput({ key: name })}
                onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                  const inputValue = e.target.value;
                  if (inputValue.length <= maxCharLimit) {
                    field.onChange(inputValue);
                    setCharCount(maxCharLimit - inputValue.length);
                  }
                }}
                value={field.value || ""}
                maxLength={maxCharLimit}
              />
              <span className="l1-text-xs l1-text-[#565365]">
                {`Max: ${charCount}/${maxCharLimit} characters`}
              </span>
            </>
          )}
        />
      </Label>
    </div>
  );
};

export default memo(TextAreaController);
